import HelTag from 'react-helmet'
import { Button } from '../../share/Elements';
import useFetch from '../../_services/fetch';
import { RaytebRequests } from '../../_services';
import { useSelector } from 'react-redux';
import { ReducerType } from '../../storeManager/ReducerType';
import { LoginInterface } from '../../Interfaces/LoginInterface';
import { LoadingFit } from '../../share/Components';

const SettingTaminInsurace = () => {
    const user = useSelector<ReducerType, LoginInterface>(
        (state) => state.reducerUser
    )

    const loginRequest = useFetch<TaminLoginInterface>(
        {
            request: RaytebRequests.Setting_TaminLogin_Post({ token: user.token }),
            onSuccess(data) {
                window.location.replace(data.taminUrl);
            },
        }
    )
    return <>
        <HelTag>
            <title>تنظیمات بیمه سلامت</title>
        </HelTag>
        <LoadingFit isLoading={loginRequest.isLoading} fixed={true} />
        <div className='py-6 px-8 '>
            <h3>بیمه تامین</h3>
            <br />
            <Button className='bg-secondary text-white p-2 mx-auto' onClick={() => loginRequest.reFetch()}>
                احراز هویت دو مرحله ای
            </Button>
        </div>
    </>
}

export default SettingTaminInsurace;